import React, { useState, useEffect } from "react";
import { Box, Button, Icon, Text, HStack } from "@chakra-ui/react";
import { FaArrowUp } from "react-icons/fa";
import { DoodleSparkle } from "./DoodleIcons";

export const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      if (window.scrollY > 400) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisible, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) return null;

  return (
    <Box
      position="fixed"
      bottom={6}
      right={6}
      zIndex={99}
      className="doodle-float"
    >
      <Button
        size="sm"
        bg="brand.900"
        color="gold.300"
        px={3.5}
        py={2}
        borderRadius="full"
        border="2px solid #06231A"
        boxShadow="3px 3px 0px #06231A"
        transition="all 0.15s ease"
        _hover={{
          bg: "brand.800",
          transform: "translate(-2px, -2px)",
          boxShadow: "5px 5px 0px #06231A",
          color: "gold.200",
        }}
        onClick={scrollToTop}
        aria-label="Scroll back to top"
      >
        <HStack gap={1.5}>
          <Icon as={FaArrowUp} fontSize="xs" />
          <Text fontSize="xs" fontWeight="bold" letterSpacing="wide">
            Top
          </Text>
          <DoodleSparkle size={12} color="#FBBF24" />
        </HStack>
      </Button>
    </Box>
  );
};

export default BackToTop;
